import { render, staticRenderFns } from "./ProgramGridItem.vue?vue&type=template&id=ea15e918"
import script from "./ProgramGridItem.vue?vue&type=script&lang=js"
export * from "./ProgramGridItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports